<template>
  <textarea
    v-model="value"
    class="textarea max-h-80 min-h-20 w-full rounded-r2 py-spacing_7 outline-none outline-offset-0"
    :placeholder="placeholder"
    :disabled="disabled"
    :error="`${error}`"
  />
</template>

<script setup lang="ts">
import type { TextAreaProps } from "~/types/schemas/common/Atom/textArea";

const value = defineModel<string>();

defineProps<TextAreaProps>();
</script>

<style scoped>
.textarea {
  @apply border-[0.5px] border-primary-600 bg-transparent px-spacing_6 font-secondary text-size_5 font-light text-neutral-800;

  &:focus {
    @apply outline-1 outline-primary-500;
  }

  &:disabled {
    @apply cursor-not-allowed border-primary-500 text-neutral-200;
  }

  &::placeholder {
    @apply text-neutral-700;
  }
}

.textarea[error="true"] {
  @apply border-none outline-[0.5px] outline-errors;
}
</style>
